import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";
import SubscriptionPlanSheet
  from "%/dynamic-component-editor/standard-components/plan-sheet/SubscriptionPlanSheet.vue";
import PaymentProviderToggle
  from "%/dynamic-component-editor/standard-components/plan-sheet/PaymentProviderToggle.vue";
import PlanIntervalSwitch from "%/dynamic-component-editor/standard-components/plan-sheet/PlanIntervalSwitch.vue";
import SubscriptionLegalFooter
  from "%/dynamic-component-editor/standard-components/plan-sheet/SubscriptionLegalFooter.vue";
import RestorePurchasesButton
  from "%/dynamic-component-editor/standard-components/plan-sheet/RestorePurchasesButton.vue";
import ManageSubscriptionButton
  from "%/dynamic-component-editor/standard-components/plan-sheet/ManageSubscriptionButton.vue";
import SubscriptionPlanTitle
  from "%/dynamic-component-editor/standard-components/subscription-card/SubscriptionPlanTitle.vue";
import SubscriptionPrice from "%/dynamic-component-editor/standard-components/subscription-card/SubscriptionPrice.vue";
import SubscriptionPlanBillingFrequency
  from "%/dynamic-component-editor/standard-components/subscription-card/SubscriptionPlanBillingFrequency.vue";
import SubscriptionPlanIncludedFeatures
  from "%/dynamic-component-editor/standard-components/subscription-card/SubscriptionPlanIncludedFeatures.vue";
import SubscriptionPlanAction
  from "%/dynamic-component-editor/standard-components/subscription-card/SubscriptionPlanAction.vue";

// The Payments group: the Subscription Plan Sheet and the elements its tree uses. Registered on
// every page (the plan-card ones too, since the sheet has no plan feed); the palette shows only the sheet.
export default class LegacyPaymentsEntity extends LegacyEntity {

  static get elements() {
    return [
      SubscriptionPlanSheet,
      PaymentProviderToggle,
      PlanIntervalSwitch,
      SubscriptionLegalFooter,
      RestorePurchasesButton,
      ManageSubscriptionButton,
      SubscriptionPlanTitle,
      SubscriptionPrice,
      SubscriptionPlanBillingFrequency,
      SubscriptionPlanIncludedFeatures,
      SubscriptionPlanAction,
    ];
  }
}
